module.exports = __webpack_public_path__ + "static/media/scr_send_money_success.e3cc5a80.png";